import type { IconData } from '@stacksjs/iconify-core'

export const airplaneDisabled: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"3\"><path stroke-linejoin=\"round\" d=\"m28.936 28.62l14.2 3.55A1.5 1.5 0 0 0 45 30.715v-1.813a3 3 0 0 0-1.53-2.615L29.966 18.69c.186-1.979.367-4.035.535-6.12c-.623-4.766-2.99-7.307-4.687-8.546a3.05 3.05 0 0 0-3.626 0c-1.698 1.239-4.065 3.78-4.687 8.546c.148 1.844.307 3.665.47 5.43M14 20.96l-9.47 5.327A3 3 0 0 0 3 28.902v1.813a1.5 1.5 0 0 0 1.864 1.455l14.2-3.55c.53 4.718.936 7.81.936 7.81l-4.766 4.56A4 4 0 0 0 14 43.88v.666a1 1 0 0 0 1.357.934L24 42.172l8.642 3.308A1 1 0 0 0 34 44.546v-.666a4 4 0 0 0-1.234-2.89L28 36.43s.067-.51.182-1.43\"/><path d=\"m6 6l38 38\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default airplaneDisabled
